import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { APP_INITIALIZER, NgModule, Optional, SkipSelf } from "@angular/core";
import { RouterModule } from "@angular/router";

import { HeaderComponent } from "./component/header/header.component";
import { SidebarComponent } from "./component/sidebar/sidebar.component";
import { ApiConfigService } from "./services/api-config.service";
import { APP_CONFIG, AppConfig } from "./services/app.config";
import { AuthInterceptor } from "./services/auth.interceptor";
import { XsrfInterceptor } from "./services/xsrf.interceptor";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { SidebarLayoutComponent } from './layouts/sidebar-layout/sidebar-layout.component';
import { PageLayoutComponent } from './layouts/page-layout/page-layout.component';

import { ButtonRendererComponent } from '@app/core/component/buttonRenderer/buttonRenderer.component'
;
import { NavbarComponent } from './component/navbar/navbar.component'
import { SharedModule } from "../shared/shared.module";
import { DropDownRendererComponent } from "./component/dropDownRenderer/dropDownRenderer.component";
import { GridActionComponent } from "@app/shared/components/grid-action/grid-action.component";


const COMPONENTS = [
  HeaderComponent,
  SidebarComponent,
  SidebarLayoutComponent,  
  PageLayoutComponent,
  ButtonRendererComponent,
  DropDownRendererComponent,
  GridActionComponent
]

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgbPopoverModule,
        SharedModule,
       
    ],
    exports: [
        ...COMPONENTS,
        //IsVisibleForAuthUserDirective,
        //HasAuthUserViewPermissionDirective
    ],
    declarations: [
        ...COMPONENTS,
        NavbarComponent,
        //IsVisibleForAuthUserDirective,
        //HasAuthUserViewPermissionDirective
    ],
    providers: [
        /* ``No`` global singleton services of the whole app should be listed here anymore!
           Since they'll be already provided in AppModule using the `tree-shakable providers` of Angular 6.x+ (providedIn: 'root').
           This new feature allows cleaning up the providers section from the CoreModule.
           But if you want to provide something with an InjectionToken other that its class, you still have to use this section.
        */
        {
            provide: APP_CONFIG,
            useValue: AppConfig
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: XsrfInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: (config: ApiConfigService) => () => config.loadApiConfig(),
            deps: [ApiConfigService],
            multi: true
        }
    
    ],
    
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() core: CoreModule) {
    if (core) {
      throw new Error("CoreModule should be imported ONLY in AppModule.");
    }
  }
}
